// @flow

import * as React from "react";
import { format, parse, isValid } from "date-fns";

import { datePickerFormFormat } from "../../../utils/formats";
import TextInput, { type InputType } from "../../Input/TextInput";

type NativeDatePickerProps = {
  input: InputType,
  minDate: Date,
  maxDate: Date,
  placeholder: string,
  isDisabled?: boolean
};

const nativeDatePickerFormat = "yyyy-MM-dd";

const handleOnChange = (e: Event, input) => {
  if (e.target instanceof HTMLInputElement) {
    const newDate = parse(e.target.value, nativeDatePickerFormat, new Date());

    input.onChange(isValid(newDate) ? format(newDate, datePickerFormFormat) : "");
  }
};

const NativeDatePicker = ({
  input,
  minDate,
  maxDate,
  placeholder,
  isDisabled
}: NativeDatePickerProps) => {
  const date = parse(input.value, datePickerFormFormat, new Date());

  return (
    <TextInput
      input={{
        ...input,
        // it's so complicated, because of possibility to change format of a stored date
        value: isValid(date) ? format(date, nativeDatePickerFormat) : "",
        onChange: (e: Event) => handleOnChange(e, input)
      }}
      onKeyDown={(e: KeyboardEvent) => e.preventDefault()}
      type="date"
      min={format(minDate, nativeDatePickerFormat)}
      max={format(maxDate, nativeDatePickerFormat)}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};

export default NativeDatePicker;
